export class Role {
    _id;
    name;
    title;
    domain;
    active;
    deleted;
}
export class DomainRolesFilter {
    _id;
    name;
    title;
    active;
    deleted;
}
export class CreateRole {
    name;
    title;
}
export class CreateDomainRole extends CreateRole {
    domain;
}
export class UpdateRole {
    name;
    title;
    active;
    deleted;
}
